export default (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.52301 5.85266C5.9122 6.92164 4.68841 8.48089 4.03281 10.2996C3.37722 12.1183 3.32467 14.0997 3.88294 15.9506C4.44121 17.8015 5.58063 19.4234 7.13252 20.5763C8.68441 21.7291 10.5663 22.3516 12.4995 22.3516C14.4328 22.3516 16.3146 21.7291 17.8665 20.5763C19.4184 19.4234 20.5578 17.8015 21.1161 15.9506C21.6744 14.0997 21.6218 12.1183 20.9662 10.2996C20.3106 8.48089 19.0868 6.92164 17.476 5.85266M12.5 2.35266V10.3527"
      stroke="#FBFBFB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
